<!-- eslint-disable no-unreachable -->
/* eslint-disable no-undef */
<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="400px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">Fotos Drone</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text--primary px-8">
          <ValidationObserver ref="form">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <ValidationProvider name="Archivos" rules="required">
                  <v-file-input
                    v-model="archivos"
                    required
                    slot-scope="{ errors, valid }"
                    :error-messages="errors"
                    accept="image/*"
                    :success="valid"
                    label="Seleccionar fotos"
                    multiple
                    show-size
                  ></v-file-input>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>

        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading">
            Guardar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment-timezone";
import {
  db,
  ref,
  storage,
  getDownloadURL,
  uploadBytesResumable,
} from "../../firebase";
// import { serverTimestamp } from "firebase/firestore";
export default {
  name: "ModalAddFotosDrone",
  data: () => ({
    loading: false,
    dialog: true,
    archivos: [],
    errors: "",
    campo: "",
    titulo: "",
    msj: "",
    url: "",
    cargos: [],
    newMensaje: {},
    caso: {},
    notificacion: false,
    investigador: {},
  }),
  props: {
    id: { type: String, default: "" },
    casoid: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
    // eslint-disable-next-line vue/require-valid-default-prop
    mensajes: { type: Array, default: [] },
    latitud: { type: Number, default: 0 },
    longitud: { type: Number, default: 0 },
  },
  async mounted() {
    //
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
  },
  methods: {
    async save() {
      this.notificacion = false;
      moment.tz.setDefault("America/Bogota");
      this.loading = true;
      const validar = await this.$refs.form.validate();
      console.log("validar", validar);
      if (!validar) {
        this.loading = false;
        return false;
      }
      await this.CasoDet();
      await this.InvestigadorDet(this.caso.uidinvestigador);

      const infoFotosDrones = await db
        .collection("fotosdrone")
        .where("roomId", "==", this.id)
        .get();

      if (infoFotosDrones.empty) {
        this.notificacion = true;
      }

      this.newMensaje.content = "";
      this.newMensaje.roomId = this.id;
      this.newMensaje._id = this.mensajes.length;
      this.newMensaje.indexId = this.mensajes.length;
      this.newMensaje.senderId = this.logueado.id;
      this.newMensaje.username = `${
        this.logueado.nombres
      }${this.logueado.identificacion.substr(0, 4)}(${this.logueado.cargo})`;
      this.newMensaje.date = moment().format("DD/MM/YYYY HH:mm", Date.now());
      this.newMensaje.timestamp = moment().format(
        "DD/MM/YYYY HH:mm",
        Date.now()
      );
      this.newMensaje.creado = Date.now();
      const totalArchivos = this.archivos.length;
      let acumulador = 0;
      const fechaActual = moment().format("YYYY-MM-DD HH:mm:ss");
      const filesPromises = Array.from(this.archivos).map((file) => {
        return new Promise((resolve, reject) => {
          const fechaHora = Math.floor(Math.random() * 10000000) + Date.now();
          const nombreArchivo = `${fechaHora}_${file.name}`;
          const storageRef = ref(storage, "fotos-dron/" + nombreArchivo);
          const uploadTask = uploadBytesResumable(storageRef, file);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              const progreso = progress.toFixed(0);
              if (progreso === "100") {
                acumulador++;
                console.log(`Progreso: ${acumulador} de ${totalArchivos}`);
              }
            },
            (error) => {
              reject(error);
            },
            async () => {
              const fileURL = await getDownloadURL(uploadTask.snapshot.ref);
              try {
                await db.collection("fotosdrone").add({
                  nombre: nombreArchivo,
                  url: fileURL,
                  latitud: this.latitud,
                  longitud: this.longitud,
                  fecha: fechaActual,
                  roomId: this.id,
                });

                resolve({
                  name: `${nombreArchivo}`,
                  size: `${file.size}`,
                  type: `${file.type}`,
                  url: `${fileURL}`,
                  extension: `${file.type.split("/")[1]}`,
                  preview: `${URL.createObjectURL(file)}`,
                });
              } catch (err) {
                reject(err);
              }
            }
          );
        });
      });
      // eslint-disable-next-line no-unreachable
      try {
        const resultadoArchivos = await Promise.all(filesPromises);
        this.newMensaje.files = resultadoArchivos;
        await db.collection("mensajes").add(this.newMensaje);
        if (this.notificacion) {
          await db.collection("notificaciones").add({
            cedula: this.investigador.identificacion,
            caso: this.caso.caso,
            momento: "Carga de primera foto",
            fechahora: fechaActual,
          });
        }
        // notificar a los usuarios que no estén conectados y que cuenten con token push
        // await this.notificarMsj();
        this.newMensaje = {};
        this.loading = false;
        this.$swal({
          icon: "success",
          title: "Fotos cargas exitosamente",
          text: "",
        });
        this.cerrarModal();
        this.$emit("actualizar");
      } catch (error) {
        this.handleError(error);
      }
    },
    async CasoDet() {
      const infoCaso = await db.collection("casos").doc(this.casoid).get();
      this.caso = infoCaso.data();
    },
    async InvestigadorDet(investigadorId) {
      const info = await db.collection("usuarios").doc(investigadorId).get();
      this.investigador = info.data();
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
  overflow: auto
  height: 240px
</style>
